/** Project surfaces sharing the persistent desktop chat and mobile chat/project switcher. */
export function projectChatIdForPath(pathname: string): string | null {
  return pathname.match(/^\/projects\/([^/]+)\/(?:overview|site-map|bugs|journeys|test-runs|user-sessions|session-reviewers|playwright-tests|security|processing-history)(?:\/|$)/)?.[1] ?? null
}
